import React, { Component } from 'react';
import "./ConversationSearch.css";
import { ChevronLeft, CloseRounded } from '@mui/icons-material';
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import axios from 'axios';
import ConversationListItem from '../ConversationListItem';
import { CircularProgress, TextField, Tooltip, Paper, FormControlLabel, Switch, List, ListItem, Chip, ListItemAvatar, Avatar, ListItemText, Grid, Typography, Box, Divider, LinearProgress, IconButton } from '@mui/material';

class ConversationSearch extends Component {
  state = {
    listMycustomer: [],
    page: 0,
    rowsPerPage: 30,
    keyword: "",
    useLimit: false,
    isLoading: false,
    searchInMessages: false,
    searchInField: "fromName"
  }

  handleKeyword = (event) => {
    this.setState({ keyword: event.target.value });
  };

  onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      this.getMyCustomerToday();
    }
  };

  getMyCustomerToday = () => {

    if(this.state.keyword.length <= 0){
      this.setState({listMycustomer: []});
      return;
    }

    this.setState({isLoading: true}, () => {
      var userData = Global.get();
      const params = {
          userId: userData.user.id,
          page: this.state.page,
          rowsPerPage: this.state.rowsPerPage,
          keywords: this.state.keyword,
          useLimit: this.state.useLimit,
          // appProfileId: Global.getAppProfile()._id,
          appProfileId: Global.getSwitchAppProfile()._id,
          searchInMessages: this.state.searchInMessages,
          searchInField: this.state.searchInField
      }

      console.log("PARAMS", params);

      axios
      .post(Api.contactListPagedSearchable(), params, Api.getRequestHeader())
      .then((response) => {
          console.log("MyCustomerToday : ", response.data);
          var customers = response.data.data;
          var contacts = [];
          var isSearchInMessages = this.state.searchInMessages;
          customers.forEach(customer => {
            if(isSearchInMessages){
              // let newData =  {
              //   photo: "https://picsum.photos/seed/picsum/200",
              //   fromName: `${customer.contact.name}`,
              //   text: customer.message.text,
              //   fromNumber: customer.from,
              //   contactId: customer.id,
              //   toNumber: customer.to,
              //   toName: customer.toName,
              //   selected: false,
              //   unreadCounter: customer.unreadCounter,
              //   assignToUserName: customer.assignToUserName,
              //   assignToUser: customer.assignToUser,
              //   firstContactAssignedTo: customer.firstContactAssignedTo,
              //   firstContactAssignedToName: customer.firstContactAssignedToName,
              //   csHelpState: customer.csHelpState,
              //   csId: customer.csId,
              //   csName: customer.csName,
              //   csArchived: customer.csArchived,
              //   contactLabel: customer.label,
              //   productCategory: customer.productCategory,
              //   cityId: customer.cityId,
              //   cityName: customer.cityName
              // };

              contacts.push(Global.generateItemConversation(customer));
            }else{
              // let newData =  {
              //   photo: "https://picsum.photos/seed/picsum/200",
              //   fromName: `${customer.fromName}`,
              //   text: customer.lastMessage,
              //   fromNumber: customer.from,
              //   contactId: customer.id,
              //   toNumber: customer.to,
              //   toName: customer.toName,
              //   selected: false,
              //   unreadCounter: customer.unreadCounter,
              //   assignToUserName: customer.assignToUserName,
              //   assignToUser: customer.assignToUser,
              //   firstContactAssignedTo: customer.firstContactAssignedTo,
              //   firstContactAssignedToName: customer.firstContactAssignedToName,
              //   csHelpState: customer.csHelpState,
              //   csId: customer.csId,
              //   csName: customer.csName,
              //   csArchived: customer.csArchived,
              //   contactLabel: customer.label,
              //   productCategory: customer.productCategory,
              //   cityId: customer.cityId,
              //   cityName: customer.cityName
              // };
              contacts.push(Global.generateItemConversation(customer));
            }
              
          });

          this.setState({listMycustomer: contacts, isLoading: false});
      })
      .catch((error) => {
        this.setState({isLoading: false});
        console.error("There was an error!", userData.user.id, error);
      });
    });

  };

  handleSwitchSearchContext = () => {
    let mode = false;
    if(this.state.searchInMessages === true){
      mode = false;
    }else{
      mode = true;
    }

    this.setState({searchInMessages: mode, keyword: this.state.keyword}, () => {
      this.getMyCustomerToday();
      // this.getCsHelpList();
    });

  }

  getFieldClassName = (fieldName) => {
    let className = "badge";
    if(this.state.searchInField === fieldName){
      className += " badge-primary";
    }else{
      className += " badge-secondary";
    }

    return className;
  }

  handleFieldSelectionChanged = (fieldName) => {
    this.setState({searchInField: fieldName}, () => {
      this.getMyCustomerToday();
    });
  }

  componentDidMount() {
    this.getMyCustomerToday();
  }

  render() { 
    return ( 

      <Paper
        sx={{
          m: "10px 5px 20px 5px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          // Desktop: isi sisa ruang dalam .conversation-list--fit (flex).
          // Mobile: tidak ada parent flex, jadi pakai tinggi viewport.
          ...(this.props.isMobile
            ? { height: "calc(100vh - 30px)" }
            : { flex: "1 1 auto", minHeight: 0 }),
            backgroundColor: "#dededd00"
        }}
        elevation={0}
        
      >
        <Box sx={{backgroundColor: "#FFFFFF", borderTopLeftRadius: "5px", borderTopRightRadius: "5px"}}>
          
              <div className={this.props.isMobile ? "text-left" : "text-right"}>
          {
              this.props.isMobile && (
                <Box>
                  <Grid container spacing={1}>
                    <Grid xs={1} item>
                      <ChevronLeft onClick={this.props.onClose} className="" style={{cursor: "pointer"}}/>
                    </Grid>
                    <Grid xs={11} item>
                      <Typography variant="h6" gutterBottom component="div">
                          Pencarian Kontak
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              )
          }
          
          {
              !this.props.isMobile && (
              <Grid container spacing={1}>
                <Grid item xs={10}>
                  <Box sx={{ml: "8px", fontWeight: "bold", textAlign: "left", pt: "5px"}}>
                    {Global.getSwitchAppProfile().label}
                  </Box>
                </Grid>
                <Grid item xs={2}>
                  <Tooltip title="Akhiri pencarian">
                    <IconButton size='small' color='error' onClick={this.props.onClose}>
                      <CloseRounded/>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>)
            }
          </div>
        </Box>
        <Divider />
        <Box sx={{pt: "10px", pl: "5px", pr: "5px", pb: '10px', backgroundColor: "#FFFFFF", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px"}}>
          <TextField
            onChange={this.handleKeyword}
            label={this.state.searchInMessages === true ? "Pencarian pesan" : "Cari nama / no wa / sales"}
            type="text"
            className="form-control"
            id="namacustomer"
            variant="outlined"
            onKeyDown={this.onKeyDownHandler}
            onBlur={() => {
                
            }}
            size='small'
          />
          {/* <br /> */}
          <Box sx={{marginTop: "10px"}}>
            <small>Field Pencarian</small>
            <div>
              <div className={this.getFieldClassName("fromName")} onClick={() => this.handleFieldSelectionChanged("fromName")} style={{cursor: "pointer"}}>Nama</div>&nbsp;
              <div className={this.getFieldClassName("from")} onClick={() => this.handleFieldSelectionChanged("from")} style={{cursor: "pointer"}}>Nomor</div>&nbsp;
              <div className={this.getFieldClassName("assignToUserName")} onClick={() => this.handleFieldSelectionChanged("assignToUserName")} style={{cursor: "pointer"}}>Sales</div>
            </div>
          </Box>
          {/* <br /> */}
          <div className="text-right">
            <FormControlLabel
              label= "Cari di dalam pesan"
              control={
                <Switch
                  checked={this.state.searchInMessages}
                  onChange={this.handleSwitchSearchContext}
                  name="switchSearchContext"
                  color="primary"
                  size='small'
                />
              }
              
            />
          </div> 
        </Box>

        {
          this.state.isLoading === true ? 
          (
            <div className="container text-center" style={{padding: 0}}>
              <LinearProgress />
            </div>
          ) : (<></>)
        }

        <div className="conversation-search-list">
          {
            !this.props.isMobile && this.state.listMycustomer.map((conversation) => {
              
              return (
                <ConversationListItem
                  onSelect={this.props.onSelect}
                  key={this.state.searchInMessages === true ? conversation.contactId : conversation.fromNumber}
                  data={conversation}
                />
              )
                    
              })
          }

          {
            (this.props.isMobile === true) && (
              <List>
              {
                  this.state.listMycustomer.map(
                      conversation => (
                          <ListItem key={`conv-item-${conversation.fromNumber}`}
                              secondaryAction={
                                  <Box edge="end" aria-label="delete" sx={{textAlign: "center"}}>
                                      {
                                          (conversation.unreadCounter && conversation.unreadCounter > 0) ? (
                                              <Box textAlign={"center"}>
                                                  <Chip label={conversation.unreadCounter} color="primary" size='small' />
                                              </Box>
                                          ) : <Box>&nbsp;</Box>
                                      }
                                      
                                      
                                      <Box textAlign={"center"} fontSize={"13px"}>
                                          5m ago
                                      </Box>
                                  </Box>
                              }
                              color='warning'
                              sx={{backgroundColor: "#FFFFFF98", mb: "8px"}}
                              onClick={() => this.props.onSelect(conversation)}
                          >
                              <ListItemAvatar>
                                  <Avatar src='aaa.jpg' alt={conversation.fromName} sx={{bgcolor: "#651fff"}}>
                                      
                                      {/* <ImageIcon /> */}
                                  </Avatar>
                              </ListItemAvatar>
                              <ListItemText primary={<strong>{conversation.fromName}</strong>} secondary={conversation.text && conversation.text.length > 50 ? conversation.text.substr(0,35) : conversation.text} />
                          </ListItem>
                      )
                  )
              }
          </List>
            )
          }
        </div>
        
      </Paper>
    );
  }
}
 
export default ConversationSearch;